import React from 'react'

function FooterBack() {
    return (
        <div className="footer-back" >
            <b>Developed by TMS AR-GE </b> | Copyright © 2021 TMS, Tüm Hakları Saklıdır.
        </div>
    )
}
export default FooterBack